import { render, staticRenderFns } from "./ShopProduct.vue?vue&type=template&id=b2bd38fa&scoped=true&"
import script from "./ShopProduct.vue?vue&type=script&lang=js&"
export * from "./ShopProduct.vue?vue&type=script&lang=js&"
import style0 from "./ShopProduct.vue?vue&type=style&index=0&id=b2bd38fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bd38fa",
  null
  
)

export default component.exports